import { FieldTypes } from '@features/campaigns/builder/components/FormFields/FieldTypes.ts';
import {
  HighImpactCreativeFieldValue,
  Step03ThematicPackagesFormValues,
} from '@features/campaigns/builder/containers/FormPages/Step03ThematicPackages/Step03ThematicPackages.types.ts';
import { ExtendedFile } from '@features/campaigns/builder/utils/areCreativeDimensionsValid.ts';
import { HighImpactCreativeType, HighImpactCreativeTypes } from '@features/campaigns/shared/types/campaign.ts';

export type HighImpactPoliticalContentLocks = Record<HighImpactCreativeType, boolean>;

export const step03ThematicPackagesDefaultValues: Step03ThematicPackagesFormValues = {
  // Thematic packages are display only; the format type field shows it locked.
  [FieldTypes.FORMAT_TYPE_VIDEO]: false,
  [FieldTypes.FORMAT_TYPE_DISPLAY]: true,
  [FieldTypes.CREATIVE_INTRO_MOBILE_IMAGE]: null,
  [FieldTypes.CREATIVE_MASTHEAD_IMAGE]: null,
  [FieldTypes.CREATIVE_MASTHEAD_ADAPTIVE_IMAGE]: null,
  [FieldTypes.CREATIVE_SKIN_IMAGE]: null,
  [FieldTypes.INTRO_MOBILE_CONTAINS_POLITICAL_CONTENT]: false,
  [FieldTypes.MASTHEAD_CONTAINS_POLITICAL_CONTENT]: false,
  [FieldTypes.MASTHEAD_ADAPTIVE_CONTAINS_POLITICAL_CONTENT]: false,
  [FieldTypes.SKIN_CONTAINS_POLITICAL_CONTENT]: false,
  [FieldTypes.LANDING_PAGE_URL]: undefined,
};

export function isNewHighImpactCreativeFile(value: HighImpactCreativeFieldValue): value is ExtendedFile[] {
  return Array.isArray(value) && value.length > 0;
}

export function resolveHighImpactPoliticalContentLocks(
  formData: Step03ThematicPackagesFormValues,
): HighImpactPoliticalContentLocks {
  return {
    [HighImpactCreativeTypes.INTRO_MOBILE]: formData[FieldTypes.INTRO_MOBILE_CONTAINS_POLITICAL_CONTENT],
    [HighImpactCreativeTypes.MASTHEAD]: formData[FieldTypes.MASTHEAD_CONTAINS_POLITICAL_CONTENT],
    [HighImpactCreativeTypes.MASTHEAD_ADAPTIVE]: formData[FieldTypes.MASTHEAD_ADAPTIVE_CONTAINS_POLITICAL_CONTENT],
    [HighImpactCreativeTypes.SKIN]: formData[FieldTypes.SKIN_CONTAINS_POLITICAL_CONTENT],
  };
}
